import * as React from 'react';
import { useEffect } from 'react';
import usePractitionerControlsContext from '../../../../../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import { useTranslation } from 'react-i18next';
import { InputUI } from '../../../../../UI/Input/Input';
import { MediaTypes } from '../../../../../../commands/practitioner/enums/MediaTypes';

interface MediaInputProps {
  index: number;
  isAudioChecked: boolean;
}
export default function MediaInput(props: MediaInputProps): JSX.Element {
  const { isAudioChecked } = props;
  const {
    practitionerMediaURI,
    setPractitionerMediaURI,
    practitionerMediaType,
    savedUri,
    lastTypeWhenURISaved,
    isMediaLoaded,
    setPractitionerMediaType,
  } = usePractitionerControlsContext();
  const valueFoInput =
    lastTypeWhenURISaved === practitionerMediaType && practitionerMediaURI === '' ? savedUri : practitionerMediaURI;

  const { t } = useTranslation();

  useEffect(() => {
    autoType(practitionerMediaURI, isAudioChecked);
  }, [isAudioChecked]);

  const inputHandler = (event: React.ChangeEvent<HTMLInputElement>): void => {
    let URI = event.target.value.trim();
    autoType(URI, isAudioChecked);
    setPractitionerMediaURI(URI);
  };

  const autoType = (URI: string, isAudio: boolean) => {
    const mediaType = detectMediaType(URI);

    if (mediaType === 'video' && URI.includes('youtube.com') && isAudio) {
      setPractitionerMediaType(MediaTypes.AUDIO);
    } else {
      switch (mediaType) {
        case 'video':
          setPractitionerMediaType(MediaTypes.VIDEO);
          break;
        case 'image':
          setPractitionerMediaType(MediaTypes.IMAGE);
          break;
        case 'audio':
          setPractitionerMediaType(MediaTypes.AUDIO);
          break;
        default:
          setPractitionerMediaType(MediaTypes.VIDEO);
      }
    }
  };

  const detectMediaType = (url: string): 'video' | 'audio' | 'image' | 'unknown' => {
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.webp'];
    const videoExtensions = ['.mp4', '.webm', '.mov', '.avi'];
    const audioExtensions = ['.mp3', '.wav', '.ogg'];

    const lowerUrl = url.toLowerCase();

    if (imageExtensions.some(ext => lowerUrl.endsWith(ext))) return 'image';
    if (videoExtensions.some(ext => lowerUrl.endsWith(ext))) return 'video';
    if (audioExtensions.some(ext => lowerUrl.endsWith(ext))) return 'audio';

    try {
      const parsedUrl = new URL(url);
      if (parsedUrl.hostname.includes('youtube.com') || parsedUrl.hostname.includes('youtu.be')) return 'video';
      if (parsedUrl.hostname.includes('soundcloud.com') || parsedUrl.hostname.includes('spotify.com')) return 'audio';
      if (parsedUrl.hostname.includes('google.com') && parsedUrl.pathname.includes('/search')) return 'image';
    } catch (error) {
      if (url.trim()) {
        console.warn('Invalid URL:', url);
      }
    }

    return 'unknown';
  };

  return (
    <InputUI
      isLoaded={isMediaLoaded}
      onChange={inputHandler}
      checked={isAudioChecked}
      title={'URL'}
      value={valueFoInput}
      label={'media-modal-content-input'}
    />
  );
}
